import request from "../request";

export const refund = ({orderId, eventId, agree_refund, uidTickets}) => {
	return request({
		url: "/refund",
		data: {
			order_id: orderId,
			event_id: eventId,
			agree_refund,
			uids: uidTickets,
		},
	});
};

export const getRefundData = ({orderId}) => {
	return request({
		url: "/refund/get-data",
		data: {
			order_id: orderId,
		},
	})
}

export const refundDo = ({orderId, uidTickets}) => {
	return request({
		url: "/refund/do",
		data: {
			order_id: orderId,
			uids: uidTickets
		},
	})
}
